import React from "react"

function IconBuildingCar({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="building-car"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-building-car"
      {...props}
    >
      <path
        d="M14.558 2.84c.326 0 .595.237.646.548l.009.107v5.123h-1.31v-4.47H7.138v4.54a.655.655 0 0 1-.548.646l-.106.008H3.382v11.603a.655.655 0 0 1-.549.646l-.106.009a.655.655 0 0 1-.646-.548l-.008-.107V8.688c0-.326.237-.596.548-.646l.106-.009h3.1l.002-4.538c0-.326.237-.596.548-.646l.106-.009h8.075zm5.856 6.978c.2 0 .382.11.477.28l.04.09 1.315 3.883c.115.181.191.39.217.615l.01.17v5.883a.764.764 0 0 1-.763.763h-.885a.764.764 0 0 1-.763-.763v-1.454h-8.547v1.454a.764.764 0 0 1-.764.763h-.884a.764.764 0 0 1-.763-.763v-1.533h.002v-4.35c0-.26.068-.504.186-.716l1.346-3.952a.546.546 0 0 1 .418-.36l.098-.01h9.26zM6.818 18.982c.18 0 .327.146.327.327v1.527c0 .181-.146.328-.327.328H5.291a.327.327 0 0 1-.327-.328V19.31c0-.18.146-.327.327-.327h1.527zM21 14.692H10.579a.164.164 0 0 0-.155.113l-.009.051v3.12h10.749v-3.12a.163.163 0 0 0-.067-.132l-.045-.023-.052-.008zm-1.478.495a1.148 1.148 0 1 1 0 2.296 1.148 1.148 0 0 1 0-2.296zm-7.465 0a1.148 1.148 0 1 1 0 2.296 1.148 1.148 0 0 1 0-2.296zm-5.239-.242c.18 0 .327.147.327.328V16.8c0 .18-.146.327-.327.327H5.291a.327.327 0 0 1-.327-.327v-1.527c0-.181.146-.328.327-.328h1.527zm13.205-4.036h-8.478l-.842 2.474H20.86l-.837-2.474zm-13.205 0c.18 0 .327.147.327.327v1.528c0 .18-.146.327-.327.327H5.291a.327.327 0 0 1-.327-.327v-1.528c0-.18.146-.327.327-.327h1.527zm4.364-5.454c.18 0 .327.146.327.327v1.527c0 .18-.146.327-.327.327H9.655a.327.327 0 0 1-.328-.327V5.782c0-.18.147-.327.328-.327h1.527z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconBuildingCar
